webpackJsonp([1],{

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(164),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(163),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-084842bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(166),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-987a33d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(165),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73790040",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(162),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0403605d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 162:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TestAndParameters"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Test & Parameters ")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-input-container', {
    staticClass: "fixed-width-container"
  }, [_c('label', [_vm._v(" voltammetric test ")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "value": _vm.currentTest
    },
    on: {
      "change": _vm.onTestChange
    }
  }, _vm._l((_vm.testParamDefs), function(value, key) {
    return _c('md-option', {
      key: value.id,
      attrs: {
        "value": key
      }
    }, [_vm._v("  \n            " + _vm._s(value.name) + "  \n          ")])
  }))], 1)], 1), _vm._v(" "), _vm._l((_vm.currentTestParamDefs), function(paramDef, paramName) {
    return _c('md-layout', {
      key: paramDef.id,
      staticClass: "row-with-margin",
      attrs: {
        "md-row": "",
        "md-align": "left"
      }
    }, [(paramDef.type === 'list') ? _c('div', [_c('md-input-container', {
      class: {
        'fixed-width-container': true
      }
    }, [_c('label', [_vm._v(" current range " + _vm._s(_vm.currentTestParamDefs[paramName].unit) + " ")]), _vm._v(" "), _c('md-select', {
      attrs: {
        "value": _vm.currentTestParamVals[paramName]
      },
      on: {
        "change": function($event) {
          _vm.onListChange(paramName, $event)
        }
      }
    }, _vm._l((_vm.allowedCurrentRanges), function(value, key) {
      return _c('md-option', {
        key: value.id,
        attrs: {
          "value": key
        }
      }, [_vm._v("\n              " + _vm._s(value) + "\n            ")])
    }))], 1)], 1) : _vm._e(), _vm._v(" "), (paramDef.type === 'number') ? _c('div', [_c('md-input-container', {
      class: {
        'fixed-width-container': true, 'md-input-invalid': _vm.testParamErrs[_vm.currentTest][paramName].flag
      }
    }, [_c('label', [_vm._v(" " + _vm._s(paramDef.name) + " (" + _vm._s(paramDef.unit) + ")  ")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "type": "number",
        "value": _vm.testParamVals[_vm.currentTest][paramName],
        "step": _vm.testParamDefs[_vm.currentTest].defs[paramName].step
      },
      on: {
        "change": function($event) {
          _vm.onNumberChange(paramName, $event)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "md-error"
    }, [_vm._v("\n            " + _vm._s(_vm.testParamErrs[_vm.currentTest][paramName].message) + "\n          ")])], 1), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "right"
      }
    }, [_vm._v(" \n          min = " + _vm._s(paramDef.minVal) + ", max = " + _vm._s(paramDef.maxVal) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (paramDef.type === 'radio') ? _c('div', _vm._l((_vm.testParamDefs[_vm.currentTest].defs[paramName].options), function(optionStr, optionKey) {
      return _c('md-radio', {
        key: optionStr.id,
        staticClass: "md-primary",
        attrs: {
          "value": _vm.testParamVals[_vm.currentTest][paramName],
          "md-value": optionKey
        },
        on: {
          "change": function($event) {
            _vm.onRadioChange(paramName, $event)
          }
        }
      }, [_vm._v("\n           " + _vm._s(optionStr) + "\n        ")])
    })) : _vm._e()])
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": ""
    }
  }, [(_vm.showDebugButton) ? _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.onDebugClick
    }
  }, [_vm._v(" \n        Debug \n      ")]) : _vm._e()], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CollectData",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Data Acquisition: test = " + _vm._s(_vm.testParamDefs[_vm.currentTest].name))])]), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(" Graphs:  ")]), _vm._v(" "), _c('md-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeVoltVsTime),
      expression: "includeVoltVsTime"
    }],
    staticClass: "md-primary",
    model: {
      value: (_vm.showVoltVsTime),
      callback: function($$v) {
        _vm.showVoltVsTime = $$v
      },
      expression: "showVoltVsTime"
    }
  }, [_vm._v(" potential vs time ")]), _vm._v(" "), _c('md-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeCurrVsTime),
      expression: "includeCurrVsTime"
    }],
    staticClass: "md-primary",
    model: {
      value: (_vm.showCurrVsTime),
      callback: function($$v) {
        _vm.showCurrVsTime = $$v
      },
      expression: "showCurrVsTime"
    }
  }, [_vm._v(" current vs time ")]), _vm._v(" "), _c('md-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeCurrVsVolt),
      expression: "includeCurrVsVolt"
    }],
    staticClass: "md-primary",
    model: {
      value: (_vm.showCurrVsVolt),
      callback: function($$v) {
        _vm.showCurrVsVolt = $$v
      },
      expression: "showCurrVsVolt"
    }
  }, [_vm._v(" current vs potential ")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": ""
    }
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "width": "110px"
    },
    on: {
      "click": _vm.onRunClick
    }
  }, [_vm._v(" \n        Run Test\n      ")]), _vm._v(" "), (_vm.showDebugButton) ? _c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "width": "110px"
    },
    on: {
      "click": _vm.onDebugClick
    }
  }, [_vm._v(" \n        Debug\n      ")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "disabled": !_vm.saveDataReady
    },
    on: {
      "click": _vm.onSaveDataClick
    }
  }, [_vm._v(" \n        Save Data\n      ")])], 1), _vm._v(" "), _c('md-dialog-prompt', {
    ref: "saveDataDialog",
    attrs: {
      "md-title": "Filename",
      "md-ok-text": "Save",
      "md-cancel-text": "Cancel",
      "md-input-placeholder": "data.txt"
    },
    on: {
      "open": _vm.onSaveDataDialogOpen,
      "close": _vm.onSaveDataDialogClose
    },
    model: {
      value: (_vm.dataFileName),
      callback: function($$v) {
        _vm.dataFileName = $$v
      },
      expression: "dataFileName"
    }
  }), _vm._v(" "), _c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.testRunning),
      expression: "testRunning"
    }],
    staticStyle: {
      "margin-left": "50px",
      "margin-top": "20px"
    },
    attrs: {
      "md-row": ""
    }
  }, [_c('md-progress', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "md-progress": _vm.progressValue
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeVoltVsTime && _vm.showVoltVsTime),
      expression: "includeVoltVsTime && showVoltVsTime"
    }],
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('div', {
    ref: "volt_vs_time_plot"
  })]), _vm._v(" "), _c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeCurrVsTime && _vm.showCurrVsTime),
      expression: "includeCurrVsTime && showCurrVsTime"
    }],
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('div', {
    ref: "curr_vs_time_plot"
  })]), _vm._v(" "), _c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeCurrVsVolt && _vm.showCurrVsVolt),
      expression: "includeCurrVsVolt && showCurrVsVolt"
    }],
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('div', {
    ref: "volt_vs_curr_plot"
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "AppToolbar"
  }, [_c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleSideNav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(" Rodeostat Web App V1.2.1")]), _vm._v(" "), _c('h1', {
    staticClass: "md-subheading",
    staticStyle: {
      "width": "70px"
    }
  }, [_vm._v(" IO Rodeo ")])], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "sideNav",
    staticClass: "md-left",
    on: {
      "open": _vm.sideNavOpen,
      "close": _vm.sideNavClose
    }
  }, [_c('md-toolbar', {
    staticClass: "md-small"
  }, [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Select Option ")])])]), _vm._v(" "), _c('div', [_c('md-list', [_c('md-list-item', [_c('md-button', {
    on: {
      "click": function($event) {
        _vm.onSideNavOptionClick('DeviceConnection')
      }
    }
  }, [_vm._v(" Device Connection ")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-button', {
    on: {
      "click": function($event) {
        _vm.onSideNavOptionClick('TestAndParameters')
      }
    }
  }, [_vm._v(" Test & Parameters ")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-button', {
    on: {
      "click": function($event) {
        _vm.onSideNavOptionClick('CollectData')
      }
    }
  }, [_vm._v(" Data Acquisition ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ExportData"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Export Data ")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DeviceConnection"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Device Connection ")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-input-container', {
    staticClass: "fixed-width-container"
  }, [_c('label', [_vm._v(" serialport-bridge host address")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.serialBridgeAddress
    },
    on: {
      "change": _vm.onSerialBridgeAddressChange
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "disabled": _vm.serialPortOpen
    },
    on: {
      "change": _vm.onSerialBridgeConnectChange
    }
  }, [_vm._v(" \n        connect to serialport-bridge\n      ")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-input-container', {
    staticClass: "fixed-width-container"
  }, [_c('label', [_vm._v(" serial port ")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "disabled": _vm.serialPortSelectDisabled,
      "value": _vm.serialPortName
    },
    on: {
      "change": _vm.onPortSelectChange
    }
  }, _vm._l((_vm.serialPortArray), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.device
      }
    }, [_vm._v(" \n            " + _vm._s(item.device) + " (" + _vm._s(item.product) + ")\n          ")])
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "value": _vm.serialPortOpen,
      "disabled": _vm.serialPortSwitchDisabled
    },
    on: {
      "change": _vm.onSerialPortOpenChange
    }
  }, [_vm._v(" \n        open serial port\n      ")])], 1), _vm._v(" "), (_vm.showDeviceInfo) ? _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v(" Device Information ")]), _vm._v(" "), _c('md-table-head')], 1)], 1), _vm._v(" "), _c('md-table-body', [_c('md-table-row', [_c('md-table-cell', [_vm._v(" Firmware Version ")]), _vm._v(" "), _c('md-table-cell', [_vm._v(" " + _vm._s(_vm.deviceFirmwareVersion) + " ")])], 1), _vm._v(" "), _c('md-table-row', [_c('md-table-cell', [_vm._v(" Hardware Variant ")]), _vm._v(" "), _c('md-table-cell', [_vm._v(" " + _vm._s(_vm.deviceHardwareVariant) + " ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": ""
    }
  }, [(_vm.showDebugButton) ? _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.onDebugClick
    }
  }, [_vm._v(" \n        Debug \n      ")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('app-toolbar'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-row": ""
    }
  }, [_c('device-connection', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentOption === 'DeviceConnection'),
      expression: "currentOption === 'DeviceConnection'"
    }]
  }), _vm._v(" "), _c('test-and-parameters', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentOption === 'TestAndParameters'),
      expression: "currentOption === 'TestAndParameters'"
    }]
  }), _vm._v(" "), _c('collect-data', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentOption === 'CollectData'),
      expression: "currentOption === 'CollectData'"
    }]
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony export (immutable) */ __webpack_exports__["b"] = number;
/* harmony export (immutable) */ __webpack_exports__["c"] = secondToMillisecond;
/* unused harmony export applyValueConverters */
/* harmony export (immutable) */ __webpack_exports__["d"] = constantParam;
/* harmony export (immutable) */ __webpack_exports__["e"] = chronoampParam;
/* harmony export (immutable) */ __webpack_exports__["f"] = cyclicParam;
/* harmony export (immutable) */ __webpack_exports__["g"] = linearSweepParam;
/* harmony export (immutable) */ __webpack_exports__["h"] = multiStepParam;
/* harmony export (immutable) */ __webpack_exports__["i"] = sinusoidParam;
/* harmony export (immutable) */ __webpack_exports__["j"] = squareWaveParam;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




// Converters for parameter values
// -----------------------------------------------------------------------------

function identity(value) {
  return value;
}

function number(value) {
  return Number(value);
}

function secondToMillisecond(value) {
  return 1000.0 * Number(value);
}

function applyValueConverters(paramVals, paramDefs) {
  var paramValsCon = {};
  for (name in paramVals) {
    paramValsCon[name] = paramDefs[name].converter(paramVals[name]);
  }
  return paramValsCon;
}

//export function paramValsToNumber(paramVals, paramDefs) {
//  let paramValsCon = {};
//  for (let testName in paramVals) {
//    paramValsCon[testName] = {};
//    for (let paramName in paramVals[testName]) {
//      let val = paramVals[testName][paramName];
//      if (paramDefs[testName].defs[paramName].type === 'number') {
//        val = Number(paramVals[testName][paramName]);
//      } 
//      paramValsCon[testName][paramName] = val;
//    }
//  }
//  return paramValsCon;
//}


// Converters for Tests
// ----------------------------------------------------------------------------


function constantParam(paramVals, paramDefs) {
  return applyValueConverters(paramVals, paramDefs);
}

function chronoampParam(paramVals, paramDefs) {
  var paramValsTmp = applyValueConverters(paramVals, paramDefs);
  var valsToOmit = ['step1Duration', 'step2Duration', 'step1Value', 'step2Value'];
  var paramValsCon = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(paramValsTmp, valsToOmit);
  paramValsCon['step'] = [[paramValsTmp.step1Duration, paramValsTmp.step1Value], [paramValsTmp.step2Duration, paramValsTmp.step2Value]];
  return paramValsCon;
}

function cyclicParam(paramVals, paramDefs) {
  var paramValsTmp = applyValueConverters(paramVals, paramDefs);
  var valsToOmit = ['scanRate', 'minValue', 'maxValue', 'startOption'];
  var paramValsCon = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(paramValsTmp, valsToOmit);
  paramValsCon.amplitude = 0.5 * Math.abs(paramValsTmp.maxValue - paramValsTmp.minValue);
  paramValsCon.offset = 0.5 * (paramValsTmp.maxValue + paramValsTmp.minValue);
  paramValsCon.period = Number(secondToMillisecond(4 * paramValsCon.amplitude / paramValsTmp.scanRate).toFixed(0));
  if (paramValsTmp.startOption === 'startMin') {
    paramValsCon.shift = 0.0;
  } else {
    paramValsCon.shift = 0.5;
  }
  return paramValsCon;
}

function linearSweepParam(paramVals, paramDefs) {
  var paramValsTmp = applyValueConverters(paramVals, paramDefs);
  var paramValsCon = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(paramValsTmp, ['scanRate']);
  var deltaVolt = Math.abs(paramValsTmp.startValue - paramValsTmp.finalValue);
  paramValsCon.duration = Number(secondToMillisecond(deltaVolt / paramValsTmp.scanRate).toFixed(0));
  return paramValsCon;
}

function multiStepParam(paramVals, paramDefs) {
  var paramValsTmp = applyValueConverters(paramVals, paramDefs);
  var paramValsCon = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(paramValsTmp, ['numSteps']);
  // --------------------------------------------------
  // TODO 
  // ---------------------------------------------------
  return paramValsCon;
}

function sinusoidParam(paramVals, paramDefs) {
  var paramValsCon = applyValueConverters(paramVals, paramDefs);
  return paramValsCon;
}

function squareWaveParam(paramVals, paramDefs) {
  var paramValsCon = applyValueConverters(paramVals, paramDefs);
  return paramValsCon;
}

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NONVALUE_TEST_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TEST_DEFS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__test_converters_js__ = __webpack_require__(44);





// Definitions for individual parameters
// ----------------------------------------------------------------------------
var CURRENT_RANGE_PARAM_DEF = {
  name: 'current range',
  unit: 'uA',
  type: 'list',
  defaultVal: '100uA',
  options: {
    '1uA': 1,
    '10uA': 10,
    '100uA': 100,
    '1000uA': 1000,
    '10000uA': 10000
  },
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["a" /* identity */]
};

var SAMPLE_RATE_PARAM_DEF = {
  name: 'sample rate',
  unit: 'Hz',
  type: 'number',
  minVal: 0.1,
  maxVal: 200.0,
  defaultVal: 100.0,
  step: 1.0,
  scale: 1.0,
  //converter: converters.identity,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["b" /* number */]
};

var QUIET_TIME_PARAM_DEF = {
  name: 'quiet time',
  unit: 's',
  type: 'number',
  minVal: 0.0,
  maxVal: 60 * 60 * 1,
  defaultVal: 0.0,
  step: 0.01,
  scale: 1000.0,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["c" /* secondToMillisecond */]
};

var VOLT_VALUE_PARAM_DEF = {
  name: 'value',
  unit: 'V',
  type: 'number',
  minVal: -10.0,
  maxVal: 10.0,
  defaultVal: 0.0,
  step: 0.1,
  scale: 1.0,
  //converter: converters.identity,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["b" /* number */]
};

var QUIET_VALUE_PARAM_DEF = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'quiet value' });

var TIME_VALUE_PARAM_DEF = {
  name: 'time',
  unit: 's',
  type: 'number',
  minVal: 0.0,
  maxVal: 60 * 60 * 24 * 2,
  defaultVal: 10.0,
  step: 0.1,
  scale: 1000,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["c" /* secondToMillisecond */]
};

var SCAN_RATE_PARAM_DEF = {
  name: 'scan rate',
  unit: 'V/s',
  type: 'number',
  minVal: 0.0,
  maxVal: 50.0,
  defaultVal: 0.5,
  step: 0.01,
  scale: 1.0,
  //converter: converters.identity,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["b" /* number */]
};

var SHIFT_PARAM_DEF = {
  name: 'shift',
  unit: '',
  type: 'number',
  minVal: 0.0,
  maxVal: 1.0,
  defaultVal: 0.0,
  step: 0.01,
  scale: 1.0,
  //converter: converters.identity,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["b" /* number */]
};

var SAMPLE_WINDOW_PARAM_DEF = {
  name: 'sample window',
  unit: 'fraction of pulse',
  type: 'number',
  minVal: 0.0,
  maxVal: 1.0,
  defaultVal: 0.2,
  step: 0.01,
  scale: 1.0,
  //converter: converters.identity,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["b" /* number */]
};

var NUM_CYCLES_PARAM_DEF = {
  name: 'cycles',
  unit: '#',
  type: 'number',
  minVal: 1,
  maxVal: 10000,
  defaultVal: 1,
  step: 1,
  scale: 1,
  //converter: converters.identity,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["b" /* number */]
};

var NUM_STEPS_PARAM_DEF = {
  name: 'steps',
  unit: '#',
  type: 'number',
  minVal: 1,
  maxVal: 50,
  defaultVal: 5,
  step: 1,
  scale: 1,
  //converter: converters.identity,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["b" /* number */]
};

var START_HILO_RADIO_PARAM_DEF = {
  name: '',
  unit: '',
  type: 'radio',
  defaultVal: 'startMin',
  options: {
    startMin: 'start minimum',
    startMax: 'start maximum'
  },
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["a" /* identity */]
};

var TIME_VOLT_ARRAY_PARAM_DEF = {
  type: 'timeVoltArray',
  timeValDefs: TIME_VALUE_PARAM_DEF,
  voltValDefs: VOLT_VALUE_PARAM_DEF
};

// Definitions for voltametric tests
// ----------------------------------------------------------------------------

var CONSTANT_TEST_DEFS = {
  currRange: CURRENT_RANGE_PARAM_DEF,
  sampleRate: SAMPLE_RATE_PARAM_DEF,
  quietTime: QUIET_TIME_PARAM_DEF,
  quietValue: QUIET_VALUE_PARAM_DEF,
  value: VOLT_VALUE_PARAM_DEF,
  duration: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, TIME_VALUE_PARAM_DEF, { name: 'duration' }),
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["d" /* constantParam */],
  plotTypes: ['currVsTime']
};

var CHRONOAMP_TEST_DEFS = {
  currRange: CURRENT_RANGE_PARAM_DEF,
  sampleRate: SAMPLE_RATE_PARAM_DEF,
  quietTime: QUIET_TIME_PARAM_DEF,
  quietValue: QUIET_VALUE_PARAM_DEF,
  step1Duration: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, TIME_VALUE_PARAM_DEF, { name: 'step 1 duration' }),
  step1Value: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'step 1 value' }),
  step2Duration: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, TIME_VALUE_PARAM_DEF, { name: 'step 2 duration' }),
  step2Value: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'step 2 value' }),
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["e" /* chronoampParam */],
  plotTypes: ['voltVsTime', 'currVsTime']
};

var CYCLIC_TEST_DEFS = {
  currRange: CURRENT_RANGE_PARAM_DEF,
  sampleRate: SAMPLE_RATE_PARAM_DEF,
  quietTime: QUIET_TIME_PARAM_DEF,
  quietValue: QUIET_VALUE_PARAM_DEF,
  minValue: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'min value', defaultVal: -1.0 }),
  maxValue: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'max value', defaultVal: 1.0 }),
  scanRate: SCAN_RATE_PARAM_DEF,
  numCycles: NUM_CYCLES_PARAM_DEF,
  startOption: START_HILO_RADIO_PARAM_DEF,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["f" /* cyclicParam */],
  plotTypes: ['voltVsTime', 'currVsTime', 'currVsVolt']
};

var LINEARSWEEP_TEST_DEFS = {
  currRange: CURRENT_RANGE_PARAM_DEF,
  sampleRate: SAMPLE_RATE_PARAM_DEF,
  quietTime: QUIET_TIME_PARAM_DEF,
  quietValue: QUIET_VALUE_PARAM_DEF,
  startValue: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'start value', defaultVal: -1.0 }),
  finalValue: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'final value', defaultVal: 1.0 }),
  scanRate: SCAN_RATE_PARAM_DEF,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["g" /* linearSweepParam */],
  plotTypes: ['voltVsTime', 'currVsTime', 'currVsVolt']
};

var MULTISTEP_TEST_DEFS = {
  currRange: CURRENT_RANGE_PARAM_DEF,
  sampleRate: SAMPLE_RATE_PARAM_DEF,
  quietTime: QUIET_TIME_PARAM_DEF,
  quietValue: QUIET_VALUE_PARAM_DEF,
  numSteps: NUM_STEPS_PARAM_DEF,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["h" /* multiStepParam */],
  plotTypes: ['voltVsTime', 'currVsTime']
};

var SINUSOID_TEST_DEFS = {
  currRange: CURRENT_RANGE_PARAM_DEF,
  sampleRate: SAMPLE_RATE_PARAM_DEF,
  quietTime: QUIET_TIME_PARAM_DEF,
  quietValue: QUIET_VALUE_PARAM_DEF,
  amplitude: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'amplitude', minVal: 0.0, defaultVal: 1.0 }),
  offset: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'offset' }),
  period: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, TIME_VALUE_PARAM_DEF, { name: 'period' }),
  numCycles: NUM_CYCLES_PARAM_DEF,
  shift: SHIFT_PARAM_DEF,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["i" /* sinusoidParam */],
  plotTypes: ['voltVsTime', 'currVsTime', 'currVsVolt']
};

var SQUAREWAVE_TEST_DEFS = {
  currRange: CURRENT_RANGE_PARAM_DEF,
  sampleRate: SAMPLE_RATE_PARAM_DEF,
  quietTime: QUIET_TIME_PARAM_DEF,
  quietValue: QUIET_VALUE_PARAM_DEF,
  amplitude: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'amplitude', minVal: 0.0, defaultVal: 0.05 }),
  startValue: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'start value', defaultVal: -0.5 }),
  finalValue: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, { name: 'final value', defaultVal: 0.5 }),
  stepValue: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, VOLT_VALUE_PARAM_DEF, {
    name: 'step value',
    step: 0.001,
    minVal: 0.001,
    maxVal: 2.0,
    defaultVal: 0.020
  }),
  sampleWindow: SAMPLE_WINDOW_PARAM_DEF,
  converter: __WEBPACK_IMPORTED_MODULE_1__test_converters_js__["j" /* squareWaveParam */],
  plotTypes: ['voltVsTime', 'currVsTime', 'currVsVolt']
};

var NONVALUE_TEST_PARAMS = ['converter', 'plotTypes'];

// Collections of all test definitions
// ----------------------------------------------------------------------------

var TEST_DEFS = {
  constant: {
    name: 'constant voltage',
    defs: CONSTANT_TEST_DEFS
  },
  chronoamp: {
    name: 'chronoamperometry',
    defs: CHRONOAMP_TEST_DEFS
  },
  cyclic: {
    name: 'cyclic',
    defs: CYCLIC_TEST_DEFS
  },
  linearSweep: {
    name: 'linear sweep',
    defs: LINEARSWEEP_TEST_DEFS
  },
  //multiStep: {
  //  name: 'multistep',
  //  defs: MULTISTEP_TEST_DEFS,
  //},
  sinusoid: {
    name: 'sinusoid',
    defs: SINUSOID_TEST_DEFS
  },
  squareWave: {
    name: 'square wave',
    defs: SQUAREWAVE_TEST_DEFS
  }
};

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__test_definitions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hardware_defs__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__test_utils__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({

  state: {
    currentOption: 'DeviceConnection',
    currentTest: 'cyclic',
    testParamDefs: __WEBPACK_IMPORTED_MODULE_3__test_definitions__["a" /* TEST_DEFS */],
    testParamVals: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__test_utils__["a" /* initParamValsFromDefs */])(__WEBPACK_IMPORTED_MODULE_3__test_definitions__["a" /* TEST_DEFS */]),
    testParamErrs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__test_utils__["b" /* initParamErrsFromDefs */])(__WEBPACK_IMPORTED_MODULE_3__test_definitions__["a" /* TEST_DEFS */]),
    hwToCurrRanges: __WEBPACK_IMPORTED_MODULE_4__hardware_defs__["a" /* HW_TO_CURR_RANGES */],
    serialBridgeAddress: 'http://localhost:5000',
    serialBridgeConnected: false,
    serialBridge: null,
    serialPortArray: [],
    serialPortName: null,
    serialPortOpen: false,
    serialPortParam: {
      baudrate: 115200,
      timeout: 10.0
    },
    deviceFirmwareVersion: null,
    deviceHardwareVariant: null,
    testRunning: false,
    progressTimer: null,
    progressTimerInterval: 100,
    testDoneTime: null,
    testDoneCallback: null,
    data: {
      time: [],
      volt: [],
      curr: []
    }
  },

  mutations: {
    setCurrentOption: function setCurrentOption(state, option) {
      state.currentOption = option;
    },
    setCurrentTest: function setCurrentTest(state, test) {
      state.currentTest = test;
    },
    setTestParamVals: function setTestParamVals(state, newVals) {
      state.testParamVals = newVals;
    },
    setTestParamValsByTest: function setTestParamValsByTest(state, payload) {
      state.testParamVals[payload.test][payload.name] = payload.value;
    },
    setTestParamErrs: function setTestParamErrs(state, newErrs) {
      state.testParamErrs = newErrs;
    },
    setTestParamErrsByTest: function setTestParamErrsByTest(state, payload) {
      state.testParamErrs[payload.test][payload.name].flag = payload.flag;
      state.testParamErrs[payload.test][payload.name].message = payload.message;
    },
    setSerialBridgeAddress: function setSerialBridgeAddress(state, address) {
      state.serialBridgeAddress = address;
    },
    setSerialBridge: function setSerialBridge(state, serialBridge) {
      state.serialBridge = serialBridge;
    },
    setSerialBridgeConnected: function setSerialBridgeConnected(state, connected) {
      state.serialBridgeConnected = connected;
    },
    setSerialPortArray: function setSerialPortArray(state, portArray) {
      state.serialPortArray = portArray;
    },
    setSerialPortName: function setSerialPortName(state, newName) {
      state.serialPortName = newName;
    },
    setSerialPortOpen: function setSerialPortOpen(state, portOpen) {
      state.serialPortOpen = portOpen;
    },
    setDeviceFirmwareVersion: function setDeviceFirmwareVersion(state, value) {
      state.deviceFirmwareVersion = value;
    },
    setDeviceHardwareVariant: function setDeviceHardwareVariant(state, value) {
      state.deviceHardwareVariant = value;
    },
    setTestRunning: function setTestRunning(state, value) {
      state.testRunning = value;
    },
    startProgressTimer: function startProgressTimer(state, callback) {
      state.progressTimer = setInterval(callback, state.progressTimerInterval);
    },
    clearProgressTimer: function clearProgressTimer(state) {
      clearInterval(state.progressTimer);
      state.progressTimer = null;
    },
    setTestDoneTime: function setTestDoneTime(state, value) {
      state.testDoneTime = value;
    },
    setTestDoneCallback: function setTestDoneCallback(state, cb) {
      state.testDoneCallback = cb;
    },
    appendData: function appendData(state, payload) {
      state.data.time.push(payload.t);
      state.data.volt.push(payload.v);
      state.data.curr.push(payload.i);
    },
    clearData: function clearData(state) {
      state.data.time = [];
      state.data.volt = [];
      state.data.curr = [];
    }
  },

  getters: {

    testParamDefsByTest: function testParamDefsByTest(state, getters) {
      return function (test, name) {
        if (name === undefined) {
          return state.testParamDefs[test]['defs'];
        } else {
          return state.testParamDefs[test]['defs'][name];
        }
      };
    },

    testParamValsByTest: function testParamValsByTest(state, getters) {
      return function (test, name) {
        if (name === undefined) {
          return state.testParamVals[test];
        } else {
          return state.testParamVals[test][name];
        }
      };
    },

    hwCurrRanges: function hwCurrRanges(state, getters) {
      return state.hwToCurrRanges[state.deviceHardwareVariant];
    },

    testDisplayName: function testDisplayName(state, getters) {
      return function (test) {
        return getters.testParamDefsByTest(test).name;
      };
    },

    currentTestDisplayName: function currentTestDisplayName(state, getters) {
      return testDisplayName(state.currentTest);
    },

    currentTestParamDefs: function currentTestParamDefs(state, getters) {
      return getters.testParamDefsByTest(state.currentTest);
    },

    currentTestParamVals: function currentTestParamVals(state, getters) {
      return getters.testParamValsByTest(state.currentTest);
    },

    allowedCurrentRanges: function allowedCurrentRanges(state, getters) {
      var allowed = getters.hwCurrRanges;
      var options = getters.currentTestParamDefs.currRange.options;
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.pick(options, allowed);
    },

    convertedTestParamVals: function convertedTestParamVals(state, getters) {
      var currVals = getters.currentTestParamVals;
      var currDefs = getters.currentTestParamDefs;
      var convertedVals = currDefs.converter(currVals, currDefs);
      return convertedVals;
    },

    testParamErrsByTest: function testParamErrsByTest(state, getters) {
      return function (test, name) {
        if (name === undefined) {
          return state.testParamErrs[test];
        } else {
          return state.testParamErrs[test][name];
        }
      };
    },

    testNameArray: function testNameArray(state, getters) {
      return function () {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.testParamVals);
      };
    },

    paramNameArray: function paramNameArray(state, getters) {
      return function (test) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.testParamVals[test]);
      };
    },

    dataLength: function dataLength(state, getters) {
      var len = 0;
      if (state.data.time !== undefined) {
        len = state.data.time.length;
      }
      return len;
    },

    runProgress: function runProgress(state, getters) {
      var value = 0;
      if (getters.dataLength !== 0) {
        if (state.testDoneTime !== null) {
          var t = state.data.time[getters.dataLength - 1];
          value = t / state.testDoneTime;
          value = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.clamp(value, 0, 1);
          value = 100 * value;
        }
      }
      return value;
    }

  }
});

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(167),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppToolbar__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DeviceConnection__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DeviceConnection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DeviceConnection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TestAndParameters__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TestAndParameters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TestAndParameters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CollectData__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CollectData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_CollectData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ExportData__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ExportData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ExportData__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    AppToolbar: __WEBPACK_IMPORTED_MODULE_1__components_AppToolbar___default.a,
    DeviceConnection: __WEBPACK_IMPORTED_MODULE_2__components_DeviceConnection___default.a,
    TestAndParameters: __WEBPACK_IMPORTED_MODULE_3__components_TestAndParameters___default.a,
    CollectData: __WEBPACK_IMPORTED_MODULE_4__components_CollectData___default.a,
    ExportData: __WEBPACK_IMPORTED_MODULE_5__components_ExportData___default.a
  },

  data: function data() {
    return {
      enableUnloadDialog: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])(['currentTest', 'currentOption']),

  methods: {
    beforeunload: function beforeunload() {
      if (this.enableUnloadDialog) {
        return 'Warning: reloading page may cause data loss in the Rodeostat application';
      }
    }
  },

  created: function created() {
    window.onbeforeunload = this.beforeunload;
  }
});

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppToolbar',
  data: function data() {
    return {
      dummy: "dummy"
    };
  },

  methods: {
    toggleSideNav: function toggleSideNav() {
      this.$refs.sideNav.toggle();
    },
    sideNavOpen: function sideNavOpen() {},
    sideNavClose: function sideNavClose() {},
    onSideNavOptionClick: function onSideNavOptionClick(optionName) {
      this.$refs.sideNav.toggle();
      this.$store.commit('setCurrentOption', optionName);
    }
  }
});

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__test_converters__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'CollectData',

  data: function data() {
    return {
      showDebugButton: false,
      progressValue: 0,
      plotVoltVsTime: null,
      testRunning: false,
      showVoltVsTime: true,
      showCurrVsTime: true,
      showCurrVsVolt: true,
      dataFileName: 'testdata.txt',
      voltVsTimeLayout: {
        xaxis: {
          title: 'time (sec)',
          zeroline: true
        },
        yaxis: {
          title: 'potential (V)',
          zeroline: true
        },
        width: 1200,
        height: 500
      },
      currVsTimeLayout: {
        xaxis: {
          title: 'time (sec)',
          zeroline: true
        },
        yaxis: {
          title: 'current (uA)',
          zeroline: true
        },
        width: 1200,
        height: 500
      },
      currVsVoltLayout: {
        xaxis: {
          title: 'potential (V)',
          zeroline: true
        },
        yaxis: {
          title: 'current (uA)',
          zeroline: true
        },
        width: 1200,
        height: 500
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    isReady: function isReady() {
      return this.serialBridgeConnected && this.serialPortOpen;
    },
    includeVoltVsTime: function includeVoltVsTime() {
      return this.currentTestParamDefs.plotTypes.includes('voltVsTime');
    },
    includeCurrVsTime: function includeCurrVsTime() {
      return this.currentTestParamDefs.plotTypes.includes('currVsTime');
    },
    includeCurrVsVolt: function includeCurrVsVolt() {
      return this.currentTestParamDefs.plotTypes.includes('currVsVolt');
    },
    saveDataReady: function saveDataReady() {
      return this.dataLength > 0 && !this.testRunning;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['currentTest', 'testParamDefs', 'testParamVals', 'testParamErrs', 'serialBridgeConnected', 'serialBridge', 'serialPortOpen', 'data']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['currentTestParamVals', 'currentTestParamDefs', 'convertedTestParamVals', 'dataLength', 'runProgress'])),

  methods: {
    onDebugClick: function onDebugClick() {
      console.log(' ');
      console.log('onDebugClick');
      console.log('currentTest = ' + this.currentTest);
      //console.log(JSON.stringify(this.currentTestParamVals));
      //console.log(JSON.stringify(this.currentTestParamDefs));
      //console.log();
      //for (let item in this.currentTestParamDefs)
      //{
      //  console.log(item);
      //}
      console.log('saveDataReady = ' + this.saveDataReady);
    },
    onSaveDataClick: function onSaveDataClick() {
      console.log('onSaveDataClick');
      this.$refs.saveDataDialog.open();
    },
    onSaveDataDialogOpen: function onSaveDataDialogOpen() {
      console.log('onSaveDataDialogOpen');
    },
    onSaveDataDialogClose: function onSaveDataDialogClose(type) {
      console.log('onSaveDataDialogClose');
      console.log('type = ' + type);
      if (type === 'ok') {
        console.log('savedata');
        var dataArray = [];
        for (var i = 0; i < this.dataLength; i++) {
          // TO DO save precision somewhere
          try {
            var dataLine = '';
            dataLine += this.data.time[i].toPrecision(4) + ', ';
            dataLine += this.data.volt[i].toPrecision(4) + ', ';
            dataLine += this.data.curr[i].toPrecision(4);
            dataArray.push(dataLine);
          } catch (e) {
            console.log(e);
          }
        }
        dataArray = [dataArray.join('\n') + '\n'];
        var blob = new Blob(dataArray, { type: "text/plain;charset=utf-8" });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_file_saver__["saveAs"])(blob, this.dataFileName, true);
      }
    },
    onRunClick: function onRunClick() {
      this.progressValue = 0;
      this.clearPlots();
      this.$store.commit('clearData');
      var command = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        command: 'setCurrRange',
        currRange: this.convertedTestParamVals.currRange
      });
      this.serialBridge.writeReadLine('setCurrRange', command);
      this.$store.commit('setTestDoneCallback', this.testDoneCallback);
      this.$store.commit('startProgressTimer', this.updateProgressBar);
      this.testRunning = true;
    },
    updateProgressBar: function updateProgressBar() {
      this.progressValue = this.runProgress;
      //console.log(this.runProgress);
    },
    testDoneCallback: function testDoneCallback() {
      this.updateProgressBar();

      var voltVsTimeData = {
        x: this.data.time,
        y: this.data.volt,
        mode: 'lines',
        visible: true
      };

      Plotly.plot(this.$refs.volt_vs_time_plot, [voltVsTimeData], this.voltVsTimeLayout);

      var currVsTimeData = {
        x: this.data.time,
        y: this.data.curr,
        mode: 'lines',
        visible: true
      };

      Plotly.plot(this.$refs.curr_vs_time_plot, [currVsTimeData], this.currVsTimeLayout);

      var currVsVoltData = {
        x: this.data.volt,
        y: this.data.curr,
        mode: 'lines',
        visible: true
      };

      Plotly.plot(this.$refs.volt_vs_curr_plot, [currVsVoltData], this.currVsVoltLayout);

      this.testRunning = false;
    },
    clearPlots: function clearPlots() {
      Plotly.deleteTraces(this.$refs.volt_vs_time_plot, 0);
      Plotly.deleteTraces(this.$refs.curr_vs_time_plot, 0);
      Plotly.deleteTraces(this.$refs.volt_vs_curr_plot, 0);
    }
  },

  mounted: function mounted() {

    var data = {
      x: [0, 1],
      y: [-1, 1],
      mode: 'lines',
      visible: false
    };

    Plotly.plot(this.$refs.volt_vs_time_plot, [data], this.voltVsTimeLayout);
    Plotly.plot(this.$refs.curr_vs_time_plot, [data], this.currVsTimeLayout);
    Plotly.plot(this.$refs.volt_vs_curr_plot, [data], this.currVsVoltLayout);
  }
});

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__serial_bridge__ = __webpack_require__(82);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'DeviceConnection',

  data: function data() {
    return {
      showDebugButton: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    serialPortSelectDisabled: function serialPortSelectDisabled() {
      return !this.serialBridgeConnected || this.serialPortOpen;
    },
    serialPortSwitchDisabled: function serialPortSwitchDisabled() {
      return !this.serialBridgeConnected;
    },
    showDeviceInfo: function showDeviceInfo() {
      return this.deviceFirmwareVersion && this.deviceHardwareVariant;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])(['currentTest', 'serialBridgeAddress', 'serialBridgeConnected', 'serialBridge', 'serialPortArray', 'serialPortName', 'serialPortOpen', 'serialPortParam', 'deviceFirmwareVersion', 'deviceHardwareVariant', 'testDoneCallback', 'data']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['currentTestParamVals', 'convertedTestParamVals'])),

  methods: {
    onDebugClick: function onDebugClick() {
      console.log('onDebugClick');
      console.log('------------');
    },
    onSerialBridgeAddressChange: function onSerialBridgeAddressChange(value) {
      this.$store.commit('setSerialBridgeAddress', value);
    },
    onSerialBridgeConnectChange: function onSerialBridgeConnectChange(value) {
      if (value) {
        this.connectSerialBridge();
      } else {
        this.disconnectSerialBridge();
      }
    },
    onSerialPortOpenChange: function onSerialPortOpenChange(value) {
      if (value) {
        this.openSerialPort();
      } else {
        this.closeSerialPort();
      }
    },
    onPortSelectChange: function onPortSelectChange(value) {
      this.$store.commit('setSerialPortName', value);
    },
    connectSerialBridge: function connectSerialBridge() {
      var _this = this;

      this.$store.commit('setSerialPortName', null);
      this.$store.commit('setSerialPortArray', []);

      this.$store.commit('setSerialBridge', new __WEBPACK_IMPORTED_MODULE_6__serial_bridge__["a" /* SerialBridge */](this.serialBridgeAddress));
      this.serialBridge.connect();

      this.serialBridge.on('connect', function () {
        _this.$store.commit('setSerialBridgeConnected', true);
        _this.serialBridge.listPorts();
      });

      this.serialBridge.on('disconnect', function () {
        _this.$store.commit('setSerialBridgeConnected', false);
        _this.$store.commit('setSerialPortName', null);
        _this.$store.commit('setSerialPortArray', []);
        _this.$store.commit('setSerialPortOpen', false);
        _this.$store.commit('setDeviceFirmwareVersion', null);
        _this.$store.commit('setDeviceHardwareVariant', null);
      });

      this.serialBridge.on('listPortsRsp', function (rsp) {
        if (rsp.success) {
          _this.$store.commit('setSerialPortArray', rsp.ports);
        }
      });

      this.serialBridge.on('openRsp', function (rsp) {
        if (rsp.success) {
          _this.$store.commit('setSerialPortOpen', true);
          var command = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ command: 'getVersion' });
          _this.serialBridge.writeReadLine('getVersion', command);
        }
      });

      this.serialBridge.on('closeRsp', function (rsp) {
        _this.$store.commit('setSerialPortOpen', false);
        _this.$store.commit('setDeviceFirmwareVersion', null);
        _this.$store.commit('setDeviceHardwareVariant', null);
      });

      this.serialBridge.on('readLineRsp', function (rsp) {

        // If rsp.success then this just indicates a successful write to the
        // serial port, but it is not yet the response to our a command. 
        if (rsp.success) {
          //console.log(JSON.stringify(rsp));
          return;
        }

        // If rsp.tag then this is a response to a command sent to the serial
        // device.  Handle the response based on the tag in the rsp.
        switch (rsp.tag) {
          case 'getVersion':
            _this.onSerialPortGetVersionRsp(rsp.line);
            break;

          case 'getVariant':
            _this.onSerialPortGetVariantRsp(rsp.line);
            break;

          case 'setCurrRange':
            // Step one when running a test
            _this.onSerialPortSetCurrRangeRsp(rsp.line);
            break;

          case 'setSamplePeriod':
            // Step two when running a test
            _this.onSerialPortSetSamplePeriodRsp(rsp.line);
            break;

          case 'setParam':
            // Step three when running a test
            _this.onSerialPortSetParamRsp(rsp.line);
            break;

          case 'getTestDoneTime':
            // Step four when running a test
            _this.onSerialPortGetTestDoneTime(rsp.line);
            break;

          case 'runTest':
            // Step five when running a test
            _this.onSerialPortRunTestRsp(rsp.line);
            break;

          case null:
            _this.onSerialPortNewTestData(rsp.line);
            break;

          default:
          // Incoming data
          //console.log('unknown tag: ' + rsp.tag); 
        }
      });
    },
    onSerialPortGetVersionRsp: function onSerialPortGetVersionRsp(rspJson) {
      var rspObj = this.convertDataToObject(rspJson);
      if (rspObj.success) {
        this.$store.commit('setDeviceFirmwareVersion', rspObj.response.version);
      } else {
        this.$store.commit('setDeviceFirmwareVersion', null);
      }
      var command = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ command: 'getVariant' });
      this.serialBridge.writeReadLine('getVariant', command);
    },
    onSerialPortGetVariantRsp: function onSerialPortGetVariantRsp(rspJson) {
      var rspObj = this.convertDataToObject(rspJson);
      if (rspObj.success) {
        this.$store.commit('setDeviceHardwareVariant', rspObj.response.variant);
      } else {
        this.$store.commit('setDeviceHardwareVariant', null);
      }
    },
    onSerialPortSetCurrRangeRsp: function onSerialPortSetCurrRangeRsp(rspJson) {
      // Response from step one when running a test
      var samplePeriod = 1000.0 / this.convertedTestParamVals.sampleRate;
      var command = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        command: 'setSamplePeriod',
        samplePeriod: Math.round(samplePeriod)
      });
      this.serialBridge.writeReadLine('setSamplePeriod', command);
    },
    onSerialPortSetSamplePeriodRsp: function onSerialPortSetSamplePeriodRsp(rspJson) {
      // Response from step two when running a test
      var _convertedTestParamVa = this.convertedTestParamVals,
          sampleRate = _convertedTestParamVa.sampleRate,
          currRange = _convertedTestParamVa.currRange,
          paramVals = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_convertedTestParamVa, ['sampleRate', 'currRange']);

      var command = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        command: 'setParam',
        test: this.currentTest,
        param: paramVals
      });
      this.serialBridge.writeReadLine('setParam', command);
    },
    onSerialPortSetParamRsp: function onSerialPortSetParamRsp(rspJson) {
      // Response from step three when running a test
      var command = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        command: 'getTestDoneTime',
        test: this.currentTest
      });
      this.serialBridge.writeReadLine('getTestDoneTime', command);
    },
    onSerialPortGetTestDoneTime: function onSerialPortGetTestDoneTime(rspJson) {
      // Response from step four when running a test
      var rspObj = this.convertDataToObject(rspJson);
      this.$store.commit('setTestDoneTime', 1.0e-3 * rspObj.response.testDoneTime);
      var command = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        command: 'runTest',
        test: this.currentTest
      });
      this.serialBridge.writeReadLine('runTest', command);
    },
    onSerialPortRunTestRsp: function onSerialPortRunTestRsp(rspJson) {
      // Response from step five when running a test
      //console.log('onSerialPortRunTestRsp');
      //console.log(rspJson);
    },
    onSerialPortNewTestData: function onSerialPortNewTestData(newDataJson) {
      var newData = this.convertDataToObject(newDataJson);
      if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(newData)) {
        newData.t = 1.0e-3 * newData.t;
        this.$store.commit('appendData', newData);
      } else {
        //console.log('data collection done');
        //console.log('length: ' + this.data.time.length);
        this.$store.commit('clearProgressTimer');
        this.testDoneCallback();
      }
    },
    disconnectSerialBridge: function disconnectSerialBridge() {
      this.serialBridge.disconnect();
    },
    openSerialPort: function openSerialPort() {
      if (this.serialPortName) {
        this.serialBridge.open(this.serialPortName, this.serialPortParam);
      }
    },
    closeSerialPort: function closeSerialPort() {
      this.serialBridge.close();
    },
    convertDataToObject: function convertDataToObject(data) {
      var dataObj = null;
      if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) === 'object') {
        dataObj = data;
      } else {
        dataObj = JSON.parse(data);
      }
      return dataObj;
    }
  }
});

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExportData',
  data: function data() {
    return {
      dummy: "dummy"
    };
  }
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'TestAndParameters',

  data: function data() {
    return {
      showDebugButton: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['currentTest', 'testParamDefs', 'testParamVals', 'testParamErrs']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['allowedCurrentRanges', 'currentTestParamVals', 'currentTestParamDefs', 'convertedTestParamVals'])),

  methods: {
    onDebugClick: function onDebugClick() {
      console.log('onDebugClick');
      console.log('------------');
      //console.log(JSON.stringify(this.currentTestParamDefs));
      //console.log(JSON.stringify(this.testParamErrs[this.currentTest]));
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.testParamVals[this.currentTest]));
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.convertedTestParamVals));
    },
    onTestChange: function onTestChange(testName) {
      this.$store.commit('setCurrentTest', testName);
    },
    onNumberChange: function onNumberChange(paramName, newValue) {
      var hasErr = this.checkNumberForErrs(this.currentTest, paramName, newValue);
      if (!hasErr) {
        this.$store.commit('setTestParamValsByTest', {
          test: this.currentTest,
          name: paramName,
          //value: Number(newValue),
          value: newValue
        });
      }
    },
    onListChange: function onListChange(paramName, newValue) {
      //console.log('onListChange: ' + paramName + ', ' + newValue);
      this.$store.commit('setTestParamValsByTest', {
        test: this.currentTest,
        name: paramName,
        value: newValue
      });
    },
    onRadioChange: function onRadioChange(paramName, newValue) {
      this.$store.commit('setTestParamValsByTest', {
        test: this.currentTest,
        name: paramName,
        value: newValue
      });
    },
    checkNumberForErrs: function checkNumberForErrs(testName, paramName, value) {
      var defs = this.testParamDefs[testName].defs[paramName];
      var boundType = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(defs, ['boundType'], ['closed', 'closed']);
      var flag = false;
      var message = '';
      if (value.length == 0) {
        flag = true;
        message = 'value must be a valid number';
      } else {
        var valueNum = Number(value);
        var maxType = boundType[1];
        var minType = boundType[0];
        if (maxType === 'closed') {
          if (valueNum > defs.maxVal) {
            flag = true;
            message = 'value is > than maximum allowed, ' + defs.maxVal;
          }
        } else {
          if (valueNum >= defs.maxVal) {
            flag = true;
            message = 'value is >= than maximum allowed, ' + defs.maxVal;
          }
        }
        if (minType === 'closed') {
          if (valueNum < defs.minVal) {
            flag = true;
            message = 'value is < than minimum allowed, ' + defs.minVal;
          }
        } else {
          if (valueNum <= defs.minVal) {
            flag = true;
            message = 'value is <= than minimum allowed, ' + defs.minVal;
          }
        }
      }

      this.$store.commit('setTestParamErrsByTest', {
        test: testName,
        name: paramName,
        flag: flag,
        message: message
      });
      return flag;
    },
    checkAllParamForErrs: function checkAllParamForErrs() {
      for (var testName in this.testParamVals) {
        for (var paramName in this.testParamVals[testName]) {
          var paramValue = this.testParamVals[testName][paramName];
          var paramType = this.testParamDefs[testName].defs[paramName].type;
          if (paramType === 'number') {
            this.checkNumberForErrs(testName, paramName, paramValue);
          }
        }
      }
    }
  },

  mounted: function mounted() {
    this.checkAllParamForErrs();
  }
});

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HW_TO_CURR_RANGES; });


var CURR_RANGE_60nA = '60nA';
var CURR_RANGE_100nA = '100nA';
var CURR_RANGE_1uA = '1uA';
var CURR_RANGE_10uA = '10uA';
var CURR_RANGE_100uA = '100uA';
var CURR_RANGE_1000uA = '1000uA';
var CURR_RANGE_10000uA = '10000uA';
var CURR_RANGE_12000uA = '12000uA';
var CURR_RANGE_24000uA = '24000uA';

var CURR_RANGE_LIST_nA = [CURR_RANGE_1uA, CURR_RANGE_10uA, CURR_RANGE_100nA, CURR_RANGE_60nA];

var CURR_RANGE_LIST_uA = [CURR_RANGE_1uA, CURR_RANGE_10uA, CURR_RANGE_100uA, CURR_RANGE_1000uA];

var CURR_RANGE_LIST_10mA = [CURR_RANGE_10uA, CURR_RANGE_100uA, CURR_RANGE_1000uA, CURR_RANGE_10000uA];

var CURR_RANGE_LIST_24mA = [CURR_RANGE_100uA, CURR_RANGE_1000uA, CURR_RANGE_12000uA, CURR_RANGE_24000uA];

var HW_TO_CURR_RANGES = {
  'nanoAmpV0.1': CURR_RANGE_LIST_nA,
  'microAmpV0.1': CURR_RANGE_LIST_uA,
  'milliAmpV0.1': CURR_RANGE_LIST_24mA,
  'AD8250_nanoAmpV0.1': CURR_RANGE_LIST_nA,
  'AD8250_microAmpV0.1': CURR_RANGE_LIST_uA,
  'AD8250_milliAmpV0.1': CURR_RANGE_LIST_24mA,
  'AD8251_nanoAmpV0.1': CURR_RANGE_LIST_nA,
  'AD8251_microAmpV0.1': CURR_RANGE_LIST_uA,
  'AD8251_milliAmpV0.1': CURR_RANGE_LIST_24mA,
  '10V_nanoAmpV0.2': CURR_RANGE_LIST_nA,
  '10V_microAmpV0.2': CURR_RANGE_LIST_uA,
  '10V_milliAmpV0.2': CURR_RANGE_LIST_24mA,
  '10V_10MilliAmpV0.2': CURR_RANGE_LIST_10mA,
  '10V_24MilliAmpV0.2': CURR_RANGE_LIST_24mA
};

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(69);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  }
});

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SerialBridge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_socket_io_client__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_socket_io_client__);






var SerialBridge = function () {
  function SerialBridge(url) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SerialBridge);

    this.url = url;
    this.socket = null;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SerialBridge, [{
    key: 'connect',
    value: function connect() {
      this.socket = __WEBPACK_IMPORTED_MODULE_2_socket_io_client___default.a.connect(this.url);
    }
  }, {
    key: 'disconnect',
    value: function disconnect() {
      if (this.socket) {
        this.socket.close();
      }
      this.socket = null;
    }
  }, {
    key: 'listPorts',
    value: function listPorts() {
      //console.log('listPorts');
      this.socket.emit('listPorts');
    }
  }, {
    key: 'open',
    value: function open(port, options) {
      this.socket.emit('open', { port: port, options: options });
    }
  }, {
    key: 'close',
    value: function close() {
      this.socket.emit('close');
    }
  }, {
    key: 'readLine',
    value: function readLine() {
      this.socket.emit('readLine');
    }
  }, {
    key: 'writeLine',
    value: function writeLine(tag, line) {
      this.socket.emit('writeLine', { tag: tag, line: line });
    }
  }, {
    key: 'writeReadLine',
    value: function writeReadLine(tag, line) {
      this.socket.emit('writeReadLine', { tag: tag, line: line });
    }
  }, {
    key: 'on',
    value: function on(eventName, callback) {
      this.socket.on(eventName, callback);
    }
  }]);

  return SerialBridge;
}();

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initParamValsFromDefs;
/* harmony export (immutable) */ __webpack_exports__["b"] = initParamErrsFromDefs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__test_definitions_js__ = __webpack_require__(45);





function initParamValsFromDefs(testParamDefs) {
  var testParamVals = {};
  for (var name in testParamDefs) {
    testParamVals[name] = {};
    for (var param in testParamDefs[name].defs) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1__test_definitions_js__["b" /* NONVALUE_TEST_PARAMS */], param)) {
        continue;
      }
      testParamVals[name][param] = testParamDefs[name].defs[param].defaultVal;
    }
  }
  return testParamVals;
}

function initParamErrsFromDefs(testParamDefs) {
  var testParamErrs = {};
  for (var name in testParamDefs) {
    testParamErrs[name] = {};
    for (var param in testParamDefs[name].defs) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1__test_definitions_js__["b" /* NONVALUE_TEST_PARAMS */], param)) {
        continue;
      }
      testParamErrs[name][param] = { flag: false, message: 'none' };
    }
  }
  return testParamErrs;
}

/***/ })

},[81]);


// WEBPACK FOOTER //
// static/js/app.f209629bbc6e366989e1.js